module.exports = __webpack_public_path__ + "img/sallero.210b8b7d.svg";